<template>
    <div>
        <pd-common-styles></pd-common-styles>

        <pd-impersonate-bar v-if="isPossesed()"></pd-impersonate-bar>

        <v-navigation-drawer :color="'#1b2e43'"
                             v-model="drawer"
                             :permanent="permanent"
                             :mini-variant="miniVariant"
                             app
                             dark
                             :style="isPossesed() ? 'top: 30px' : ''">
            <v-list-item>
                <v-list-item-content>
                    <v-img :src="`${urlBundles.baseUrl}assets/passdelivery_white.svg`"
                           :height="24"
                           position="left center"
                           contain
                           v-if="!miniVariant"></v-img>
                    <v-img :src="`${urlBundles.baseUrl}assets/passdelivery-red-point.svg`"
                           :height="24"
                           contain
                           v-if="miniVariant"></v-img>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list nav dense shaped style="padding: 8px !important;">
                <v-list-item-group v-model="group">
                    <v-list-item @click="gotoUrl(urlBundles.dashboard)"
                                 v-if="$hasRole([2, 4, 3], userInfo.currentRoleId)">
                        <v-list-item-icon>
                            <v-icon>mdi-view-dashboard</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{
              $t("pages.dashboard.title")
                            }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.orders)"
                                 v-if="$hasRole([2, 4, 3], userInfo.currentRoleId)">
                        <v-list-item-icon>
                            <v-icon>mdi-clipboard-list-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ $t("pages.orders.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.riders)"
                                 v-if="$hasRole([2], userInfo.currentRoleId)">
                        <v-list-item-icon>
                            <v-icon>mdi-bike-fast</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ $t("pages.riders.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.manageWallet)"
                                 v-if="$hasRole([4], userInfo.currentRoleId) && getShowFiscalInfo()">
                        <v-list-item-icon>
                            <v-icon>mdi-wallet-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ $t("pages.wallet.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.vehicles)"
                                 v-if="$hasRole([2, 4], userInfo.currentRoleId)">
                        <v-list-item-icon>
                            <v-icon>mdi-truck</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ $t("pages.vehicles.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.ridersAvailability)"
                                 v-if="$hasRole([4], userInfo.currentRoleId)">
                        <v-list-item-icon>
                            <v-icon>mdi-timetable</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ $t("pages.ridersAvailability.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.stores)"
                                 v-if="$hasRole([2], userInfo.currentRoleId)">
                        <v-list-item-icon>
                            <v-icon>mdi-storefront</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ $t("pages.stores.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.storeStatistic)"
                                 v-if="$hasRole([2], userInfo.currentRoleId)">
                        <v-list-item-icon>
                            <v-icon>mdi-google-analytics</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ $t("pages.store_statistic.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.riderStatistic)"
                                 v-if="$hasRole([4], userInfo.currentRoleId)">
                        <v-list-item-icon>
                            <v-icon>mdi-google-analytics</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ $t("pages.store_statistic.title") }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar dense
                   :color="$vuetify.theme.dark ? '': 'white'"
                   outlined
                   elevate-on-scroll
                   app
                   :style="        isPossesed() ? 'margin-top: 30px' : ''">
            <v-app-bar-nav-icon @click="setMiniVariant"></v-app-bar-nav-icon>

            <img v-if="logo" :src="`${urlBundles.img}/${logo}`" class="store-logo" />
            <v-toolbar-title class="store-description">{{ title }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-checkbox v-model="darkMode"
                        color="yellow"
                        off-icon="mdi-theme-light-dark"
                        on-icon="mdi-theme-light-dark"
                        @click="toggleDarkMode"
                        class="theme-button">
            </v-checkbox>

            <v-toolbar-title class="account-info">
                <div class="account-name">{{ userInfo.name }}</div>
                <div class="account-role">
                    {{ $t("roles." + userInfo.currentRoleId).toUpperCase() }}
                </div>
            </v-toolbar-title>
            <v-avatar color="indigo" size="32" style="        margin-right: 10px">
                <span class="white--text">{{ initials }}</span>
            </v-avatar>

            <v-menu :rounded="false">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="user-options-btn">
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list dense flat :elevation="1">
                    <v-list-item @click="gotoUrl(urlBundles.myAccount)">
                        <v-list-item-title>
                            {{ $t("pages.my_account.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="gotoUrl(urlBundles.chooseProfile)"
                                 v-if="userInfo.storeRoles.length > 1">
                        <v-list-item-title>
                            {{ $t("pages.choose_profile.title") }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openUrl(urlBundles.help)"
                                 v-if="$hasRole([2], userInfo.currentRoleId)">
                        <v-list-item-title>{{ $t("common.guide") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logout()">
                        <v-list-item-title>{{ $t("common.logout") }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <div v-if="$hasRole([2], userInfo.currentRoleId) && storeDisabled"
             class="warning-bar">
            {{ $t("errors.storeDisabled") }}
        </div>
        <snackbar-hub></snackbar-hub>
        <communication-hub></communication-hub>
    </div>
</template>

<script>
    import { UrlBundles, UserInfo, EventHub } from "Libs/core";
    import isMobile from "ismobilejs";
    import PdCommonStyles from "Components/pd-common-styles";
    import PdImpersonateBar from "Components/pd-impersonate-bar";
    import SnackbarHub from "Components/snackbar-hub";
    import CommunicationHub from "Components/communication-hub";
    import _ from "lodash";
    import axios from "axios";
    import moment from "moment";

    export default {
        data() {
            return {
                axios: axios,
                drawer: this.$vuetify.breakpoint.mobile ? false : true,
                eventHub: EventHub,
                genericErrorSnackbar: false,
                isMobile: isMobile,
                miniVariant: this.$vuetify.breakpoint.mobile ? false : true, //this.$vuetify.breakpoint.mobile,
                moment: moment,
                permanent: this.$vuetify.breakpoint.mobile ? false : true,
                serverErrorSnackbar: false,
                snackbar: false,
                storeDisabled: false,
                storeLogo: null,
                storeTitle: null,
                successSnackbar: { status: false, msg: null },
                urlBundles: UrlBundles,
                userInfo: UserInfo,
                darkMode: false
            };
        },
        computed: {
            logo() {
                return this.storeLogo;
            },
            title() {
                return this.storeTitle;
            },

            initials() {
                let initials = this.userInfo.name.match(/\b\w/g) || [];
                return ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
            }
        },
        methods: {
            getShowFiscalInfo() {
                return this.userInfo.showFiscalInfo == "True";
            },
            isPossesed() {
                return (
                    window.ADMIN_INFO !== undefined &&
                    (window.ADMIN_INFO || {}).ImpersonateEmail !== null &&
                    (window.ADMIN_INFO || {}).ImpersonateEmail !== ""
                );
            },
            gotoUrl(url) {
                window.location.href = url;
            },
            openUrl(url) {
                window.open(url, "_blank");
            },
            logout() {
                if (window.hasOwnProperty("JsInterface")) {
                    window.JsInterface.logout();
                }
                if (this.isMobile(window.navigator).apple.device && window.webkit) {
                    window.webkit.messageHandlers.logout.postMessage({});
                }

                localStorage.clear();
                window.location.href = this.urlBundles.logout;
            },
            setMiniVariant() {
                !this.$vuetify.breakpoint.mobile &&
                    (this.miniVariant = !this.miniVariant);
                this.$vuetify.breakpoint.mobile && (this.drawer = !this.drawer);
                localStorage.setItem("miniVariant", this.miniVariant);
            },
            oneHourCheck() {
                if (localStorage.getItem("storeHeaderInfo") !== null) {
                    return (
                        new Date().getTime() -
                        JSON.parse(localStorage.getItem("storeHeaderInfo")).lastUpdate >
                        3600000
                    );
                } else {
                    return false;
                }
            },
            getHeaderInfo() {
                axios.get(this.urlBundles.storesApi + "/GetHeaderInfo").then((res) => {
                    res.data.lastUpdate = new Date().getTime();
                    localStorage.setItem("storeHeaderInfo", JSON.stringify(res.data));
                    this.setStoreDisabled();
                    this.setStoreTitle();
                    this.setStoreLogo();
                });
            },
            setStoreDisabled() {
                this.storeDisabled =
                    JSON.parse(localStorage.getItem("storeHeaderInfo")).disabled || false;
            },
            setStoreLogo() {
                this.storeLogo =
                    JSON.parse(localStorage.getItem("storeHeaderInfo")).logo || "";
            },
            setStoreTitle() {
                this.storeTitle =
                    JSON.parse(localStorage.getItem("storeHeaderInfo")).description || "";
            },
            toggleDarkMode() {
                this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
                this.darkMode = this.$vuetify.theme.dark;
                localStorage.setItem("darkTheme", this.$vuetify.theme.dark.toString());


                this.changeScrollBarTheme();
            },
            changeScrollBarTheme() {
                var darkStyle = "::-webkit-scrollbar-track {background: #121212;}    ::-webkit-scrollbar-thumb {background: #3e3e3e;border: solid 3px #121212;border-radius: 7px;}    ::-webkit-scrollbar-thumb:hover {background: white;}";

                var lightStyle = "::-webkit-scrollbar-track {background: #f0f0f0;}    ::-webkit-scrollbar-thumb {background: #7b7b7b;border: solid 3px #f0f0f0;border-radius: 7px;}    ::-webkit-scrollbar-thumb:hover {background: #272727;}";

                if (this.$vuetify.theme.dark)
                    document.getElementById("styleScrollbar").innerHTML = darkStyle;
                else
                    document.getElementById("styleScrollbar").innerHTML = lightStyle;
            }
        },
        mounted() {
            this.$nextTick(() => {
                if (!this.$vuetify.breakpoint.mobile) {
                    if (localStorage.getItem("miniVariant") !== null) {
                        this.miniVariant = eval(localStorage.getItem("miniVariant"));
                    } else {
                        localStorage.setItem("miniVariant", true);
                        this.miniVariant = true;
                    }
                }

                if (
                    localStorage.getItem("storeHeaderInfo") === null ||
                    this.oneHourCheck()
                ) {
                    this.getHeaderInfo();
                } else {
                    this.setStoreDisabled();
                    this.setStoreTitle();
                    this.setStoreLogo();
                }

                const themeDark = localStorage.getItem("darkTheme");

                if (themeDark) {

                    if (themeDark === "true") {
                        this.$vuetify.theme.dark = true;
                    } else {
                        this.$vuetify.theme.dark = false;
                    }

                } else if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
                    this.$vuetify.theme.dark = true;
                    localStorage.setItem("darkTheme", this.$vuetify.theme.dark.toString());
                }

                this.darkMode = this.$vuetify.theme.dark;

                this.changeScrollBarTheme();
            });
        },
        props: {
            color: {
                type: String,
                default: "#fff",
            },
        },
        components: {
            PdCommonStyles,
            PdImpersonateBar,
            SnackbarHub,
            CommunicationHub
        },
    };
</script>

<style lang="scss">
    .store-logo {
        height: 36px;
        margin-right: 20px;
    }

    .store-description {
        font-size: 18px;
    }

    .warning-bar {
        height: 48px;
        line-height: 48px;
        margin-top: 48px;
        text-align: center;
        background: #ff98009e;
        width: 100%;
        color: #fff;
    }

    .user-options-btn {
        height: 32px !important;
        width: 32px !important;
    }

    .account-info {
        text-align: right;
        margin-right: 20px;

        .account-name {
            font-size: 0.8rem;
            font-weight: bold;
        }

        .account-role {
            font-size: 0.6rem;
        }
    }

    .v-application--is-ltr .v-list.v-sheet--shaped {
        padding-left: 0;
    }

    .v-list--nav .v-list-item {
        border-radius: 0;
    }

    .theme-button {
        height: 24px !important;
        margin-right: 15px;
    }

    ::-webkit-scrollbar {
        width: 15px;
    }
</style>